import * as React from 'react';



interface Props {
    buttonClasses?: string;
    initiallyOpen?: boolean;
    buttonText?: string;
}

interface State {
    open: boolean;
    buttonText: string;
}

export class SignUpNewsletterModalButton extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            open: !!props.initiallyOpen,
            buttonText: props.buttonText ? props.buttonText : 'SIGN UP TO THE NEWSLETTER',
        };
    }

    public render() {
        return (
            <React.Fragment>
                <button id={'sign_up_newsletter_cta'} className={`${this.props.buttonClasses || ''}`} onClick={this.toggleModal(true)}>{this.state.buttonText}</button>
            </React.Fragment>
        );
    }

    private toggleModal = (open: boolean) => {
        return () => {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'Rv8BTZ']);
        };
    }
}
